import { ProdClient } from 'client/client';
import { Contact as ContactModel } from 'models';

export const peopleCall = (
  pageNum: number,
  city?: string,
  department?: string,
  names?: string,
  locale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE!,
) => {
  let call = ProdClient.items<ContactModel>().type('contact').includeTotalCountParameter().languageParameter(locale);
  if (!pageNum && !city && !department && !names) {
    return call.elementsParameter(['display_name']).orderByAscending('elements.display_name');
  }

  if (city) {
    call = call.equalsFilter('elements.city', encodeURIComponent(city.charAt(0).toUpperCase() + city.slice(1)));
  }
  if (department) {
    call = call.equalsFilter('elements.department', encodeURIComponent(department));
  }
  if (names) call = call.inFilter('elements.display_name', encodeURIComponent(names).split(','));

  call = call.limitParameter(12).skipParameter((pageNum - 1) * 12);
  return call;
};
